export const GET_CLOUD_ENGINEERING_TASKS = `
  query GetCloudEngineeringTasks(
    $mapContractId: String
    $status: String
    $assignedTo: String
    $type: String
  ) {
    getCloudEngineeringTasks(
      mapContractId: $mapContractId
      status: $status
      assignedTo: $assignedTo
      type: $type
    ) {
      error {
        code
        message
        statusCode
      }
      data {
        id
        type
        resourceId
        mapContractId
        accountId
        productCode
        status
        assignedTo
        createdDate
        completedDate
        notes
      }
    }
  }
`
